module.exports = __webpack_public_path__ + "static/img/2031.9d591ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2031.jpg
// module id = 321
// module chunks = 0